import React, { PropsWithChildren } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Popover, {
  HorizontalOrigin,
} from "@src/sharedComponents/Popover/Popover";
import ThreeDotsButton from "@src/sharedComponents/ThreeDotsButton/ThreeDotsButton";

import styles from "./Menu.module.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  anchorRef: React.MutableRefObject<HTMLDivElement | null>;
  anchorOriginHorizontal?: HorizontalOrigin;
  transformOriginHorizontal?: HorizontalOrigin;
  className?: string;
  classNamePopoverMenu?: string;
}

const ThreeDotsPopoverMenu: React.FC<PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  onOpen,
  anchorRef,
  anchorOriginHorizontal,
  transformOriginHorizontal,
  className,
  classNamePopoverMenu,
  children,
}) => {
  return (
    <Popover
      open={isOpen}
      onClose={onClose}
      anchor={anchorRef.current}
      anchorOriginHorizontal={anchorOriginHorizontal}
      transformOriginHorizontal={transformOriginHorizontal}
      popoverElement={
        <ThreeDotsButton
          className={className}
          anchorRef={anchorRef}
          onClick={onOpen}
        />
      }
    >
      <div className={toClassName(styles.menu, classNamePopoverMenu)}>
        {children}
      </div>
    </Popover>
  );
};

export default ThreeDotsPopoverMenu;
